const castValue = (type, currentValue) => {
  let value;

  if (type === 'integer') {
    value = parseInt(currentValue, 10);
  } else if (type === 'float') {
    value = parseFloat(currentValue);
  } else {
    value = currentValue;
  }

  return value;
};

export default castValue;
